import script from "./EmojiPickerBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./EmojiPickerBtn.vue?vue&type=script&setup=true&lang=js"

import "./EmojiPickerBtn.vue?vue&type=style&index=0&id=3b2f8550&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b2f8550"]])

export default __exports__